module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2lyY2xlLWNoZWNrLXNvbGlkIiBkPSJNMCwxMEExMCwxMCwwLDEsMSwxMCwyMCwxMCwxMCwwLDAsMSwwLDEwWk0xNC41MjMsOC4yNzNhMS4wOTQsMS4wOTQsMCwwLDAtMS41NDctMS41NDdMOC43NSwxMC45NTMsNy4wMjMsOS4yMjdhMS4wOTQsMS4wOTQsMCwwLDAtMS41NDcsMS41NDdsMi41LDIuNWExLjEsMS4xLDAsMCwwLDEuNTQ3LDBaIiBmaWxsPSIjMDA2ZWQ2Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project-completed-icon.svg
// module id = LNx3
// module chunks = 26